import { PureComponent } from "react";

import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";

import { type BillDocumentType } from "entity/bill/Bill/Bill.api.types";
import { BillStatusTag, type BillStatusType } from "entity/bill/common/BillStatus/BillStatus";

export interface IBillStatusResponse {
    paymentStatus?: BillStatusType;
    isSubRequested: boolean;
    documentType?: BillDocumentType;
}

export class BillStatusCell extends PureComponent<IGridCellRenderProps<IBillStatusResponse>> {
    render() {
        const { cellValue, field } = this.props;
        if (!cellValue || cellValue.paymentStatus === undefined) {
            return null;
        }

        return (
            <span data-testid={field.full}>
                <BillStatusTag
                    isSubRequested={cellValue.isSubRequested}
                    status={cellValue.paymentStatus}
                    documentType={cellValue.documentType}
                    useBds
                />
            </span>
        );
    }
}

export const columnBillStatus: IClientGridColumn<IBillStatusResponse> = {
    columnType: GridColumnType.billStatus,
    Cell: BillStatusCell,
};
